import type { UserRole } from '@/types';

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  CONTENT_MANAGER: 'content_manager',
  SUPPORT: 'support',
  ANALYST: 'analyst',
  PATIENT: 'patient',
} as const;

export const ADMIN_PANEL_ROLES: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.CONTENT_MANAGER,
  USER_ROLES.SUPPORT,
  USER_ROLES.ANALYST,
];

export const APP_USER_ROLES: UserRole[] = [USER_ROLES.PATIENT];

export function isAdminPanelRole(role: UserRole | string): boolean {
  return (ADMIN_PANEL_ROLES as string[]).includes(role);
}

export function isAppUserRole(role: UserRole | string): boolean {
  return role === USER_ROLES.PATIENT;
}

/** Map pre-MVP DB/JWT role strings to current UserRole values */
const LEGACY_ROLE_ALIASES: Record<string, UserRole> = {
  admin: USER_ROLES.SUPER_ADMIN,
  clinic_admin: USER_ROLES.SUPER_ADMIN,
  doctor: USER_ROLES.SUPER_ADMIN,
  veterinarian: USER_ROLES.CONTENT_MANAGER,
  staff: USER_ROLES.SUPPORT,
};

export function normalizeUserRole(role: UserRole | string | undefined): UserRole {
  if (!role) return USER_ROLES.PATIENT;
  return LEGACY_ROLE_ALIASES[role] ?? (role as UserRole);
}
